import { createApp } from 'vue';

import { copy } from '@/directive/copy';
import { exposure } from '@/directive/exposure';
import LoadingComponent from '@/directive/LoadingCom.vue';

export default defineNuxtPlugin((nuxtApp) => {
  const relativeCls = 'nextmar-loading-parent--relative';
  const minHeightCls = 'nextmar-loading-parent--min-height';
  const accountMinHeightCls = 'nextmar-loading-parent--account-min-height';

  function addClass(el, className) {
    // 如果当前元素样式列表中没有className
    if (!el.classList.contains(className)) {
      el.classList.add(className);
    }
  }

  function removeClass(el, className) {
    el.classList.remove(className);
  }

  function append(el, addStyle = false) {
    const style = getComputedStyle(el);
    if (['absolute', 'fixed', 'relative'].indexOf(style.position) === -1) {
      addClass(el, relativeCls);
    }
    if (addStyle) {
      if (!['minHeight'].includes(style.position)) {
        if (location.href.includes('/account/')) {
          addClass(el, accountMinHeightCls);
        } else {
          addClass(el, minHeightCls);
        }
      }
    }
    el.appendChild(el.instance.$el);
  }

  function remove(el) {
    removeClass(el, relativeCls);
    removeClass(el, minHeightCls);
    removeClass(el, accountMinHeightCls);
    try {
      // 本地调试时遇到过报错
      el.removeChild(el.instance.$el);
    } catch (error) {
      console.warn(error);
    }
  }

  nuxtApp.vueApp.directive('vgLoading', {
    // 页面使用（挂载元素设有最小高度）
    mounted(el, binding) {
      const app = createApp(LoadingComponent, { zIndex: binding.arg || '1997000' }); // 通过 v-vgLoading:199="" 形式传递 zIndex
      const instance = app.mount(document.createElement('div'));
      el.instance = instance;
      append(el, true);
      if (binding.value) {
        instance?.show();
      }
    },
    updated(el, binding) {
      if (binding.value !== binding.oldValue) {
        if (binding.value) {
          el.instance?.show();
        } else {
          el.instance?.hide();
        }
      }
    },
    unmounted(el) {
      remove(el);
    },
  });

  nuxtApp.vueApp.directive('vLoading', {
    // 小区域使用（挂载元素没有最小高度）
    mounted(el, binding) {
      const app = createApp(LoadingComponent, { zIndex: binding.arg || '1997000' }); // 通过 v-vgLoading:199="" 形式传递 zIndex
      const instance = app.mount(document.createElement('div'));
      el.instance = instance;
      append(el);
      if (binding.value) {
        instance?.show();
      }
    },
    updated(el, binding) {
      if (binding.value !== binding.oldValue) {
        if (binding.value) {
          el.instance?.show();
        } else {
          el.instance?.hide();
        }
      }
    },
    unmounted(el) {
      remove(el);
    },
  });

  // 曝光指令
  nuxtApp.vueApp.directive('exposure', exposure);
  // 复制指令
  nuxtApp.vueApp.directive('copy', copy);
});
